/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchema } from './ClaimsSchema';

export const MetaSchema: core.serialization.ObjectSchema<serializers.MetaSchema.Raw, Truvity.MetaSchema> =
    core.serialization.object({
        schema: ClaimsSchema,
        slug: core.serialization.string().optional(),
        version: core.serialization.number().optional(),
    });

export declare namespace MetaSchema {
    export interface Raw {
        schema: ClaimsSchema.Raw;
        slug?: string | null;
        version?: number | null;
    }
}
